<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_vi"></a><em>Also by Donna Leon</em></p>
<p class="noindent1">Death at La Fenice<br/>Death in a Strange Country<br/>Dressed for Death<br/>Death and Judgment<br/>Quietly in Their Sleep<br/>A Noble Radiance<br/>Fatal Remedies<br/>Friends in High Places<br/>A Sea of Troubles<br/>Wilful Behaviour<br/>Uniform Justice<br/>Doctored Evidence<br/>Blood from a Stone<br/>Through a Glass, Darkly<br/>Suffer the Little Children<br/>The Girl of His Dreams<br/>About Face<br/>A Question of Belief<br/>Handel’s Beastiary</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?179bc99b